module.exports = __webpack_public_path__ + "media/logos/logo_ENSECH-b1145dce.png";